import apiClient from './apiService';

export type WfState = 'draft' | 'submitted' | 'approved' | 'rejected';
export type WfAction = 'created' | 'submitted' | 'approved' | 'rejected' | 'reopened' | 'updated';

export interface WfEvent {
  action: WfAction;
  by_id: number;
  by_name: string;
  on: string | null;
  note: string | null;
}

export interface WfTimeline {
  success: boolean;
  kind: string;
  id: number;
  title: string;
  workflow_state: WfState;
  /** 0 when the record is inactive — transitions are blocked (read-only timeline). */
  is_active?: number;
  events: WfEvent[];
  permissions: { submit: boolean; approve: boolean; reject: boolean; reopen?: boolean };
}

// Polymorphic maker-checker workflow client. One service for every resource —
// pass the resource_kind (e.g. 'rsk_register') + record id.
class WorkflowService {
  private base = '/api/v1/wf';

  async timeline(kind: string, id: number): Promise<WfTimeline> {
    const r = await apiClient.get<WfTimeline>(`${this.base}/${kind}/${id}/timeline`);
    return r.data;
  }
  async submit(kind: string, id: number): Promise<WfTimeline> {
    const r = await apiClient.patch<WfTimeline>(`${this.base}/${kind}/${id}/submit`);
    return r.data;
  }
  async approve(kind: string, id: number, note?: string): Promise<WfTimeline> {
    const r = await apiClient.patch<WfTimeline>(`${this.base}/${kind}/${id}/approve`, { note });
    return r.data;
  }
  async reject(kind: string, id: number, reason: string): Promise<WfTimeline> {
    const r = await apiClient.patch<WfTimeline>(`${this.base}/${kind}/${id}/reject`, { reason });
    return r.data;
  }
  async reopen(kind: string, id: number): Promise<WfTimeline> {
    const r = await apiClient.patch<WfTimeline>(`${this.base}/${kind}/${id}/reopen`);
    return r.data;
  }
}

const workflowService = new WorkflowService();
export default workflowService;
